var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfettiOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.438 46.81c-.653-1.764-19.98 3.758-20.972 1.417l-2.328-5.907c.474 1.385 19.92-3.872 20.882-1.607l2.418 6.097z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.431 46.89c.864 2.185-4.353 5.956-10.456 8.48l-2.391-6.026c6.067-2.528 11.377-6.145 10.456-8.48.035.004 1.992 4.974 2.391 6.027z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.09 35.859c-.652-1.765-19.976 3.755-20.968 1.414l-2.329-5.91c.474 1.385 19.916-3.87 20.88-1.604l2.418 6.1z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.881 20.149C27.27 16.08 10.435 11.193 8.57 6.413L6.24.502c1.98 5.08 18.069 8.05 20.259 13.55l2.383 6.097z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.121 35.9c.371.978-2.468 3.365-8.534 5.894-6.067 2.53-8.438 5.651-8.06 6.557 0 0-1.844-4.633-2.39-6.026-.52-1.282 1.993-4.028 8.06-6.557 6.066-2.53 8.97-4.838 8.534-5.894 0 0 1.951 5.006 2.39 6.026z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.74 19.741c.748 1.884-1.423 5.17-6.544 9.423-5.082 4.22-8.444 7.132-8.097 7.999 0 0-1.845-4.634-2.39-6.027-.522-1.282 2.986-3.854 8.096-7.999 5.071-4.113 7.204-7.729 6.544-9.422 0 0 1.951 5.006 2.39 6.026z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.029,
    y1: 43.304,
    x2: 39.536,
    y2: 45.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.796,
    y1: 47.476,
    x2: 39.405,
    y2: 48.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.695,
    y1: 32.339,
    x2: 35.201,
    y2: 34.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.373,
    y1: 9.112,
    x2: 29.753,
    y2: 11.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.423,
    y1: 38.194,
    x2: 34.744,
    y2: 40.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 12.279,
    y1: 24.659,
    x2: 28.299,
    y2: 26.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiOrange);
export default __webpack_public_path__ + "static/media/confetti-orange.c2d0d8f8.svg";
export { ForwardRef as ReactComponent };